<label class="mb-2">{{ title() | translate }}</label>

<app-form-array-table
  [formArray]="formControls()"
  [canAdd]="canAdd()"
  (add)="createNewFileGroup.emit()"
>
  <ng-template #headers>
    <th class="col-preview"></th>
    @if (showIsPublicCheckbox()) {
      <th class="col-public" scope="col">
        {{ "general.uploadFilePublic" | translate }}
      </th>
    }
    <th class="col-input">{{ "general.title" | translate }}</th>
    <th class="col-input">{{ "general.description" | translate }}</th>
    <th class="col-action"></th>
  </ng-template>

  <ng-template #row let-formGroup let-index="index">
    <ng-container [formGroup]="formGroup" (ngSubmit)="onFormSubmit($event)">
      <td class="col-preview">
        <div class="preview-placeholder"></div>
      </td>

      @if (showIsPublicCheckbox()) {
        <td class="col-public">
          <input
            type="checkbox"
            class="form-check-input is-public-checkbox"
            [attr.aria-label]="'general.uploadFilePublic' | translate"
            [formControl]="formGroup.controls.isPublic"
          />
        </td>
      }

      <td class="col-input">
        @if (isPreviouslyUploadedFile(formGroup)) {
          <span class="readonly-field">
            {{ formGroup.controls.title.value || "-" }}
          </span>
        } @else {
          <app-validated-input
            [inputFormControl]="formGroup.controls.title"
            inputFormControlName="title"
            [omitKeydownEnter]="true"
          />
        }
      </td>

      <td class="col-input">
        @if (isPreviouslyUploadedFile(formGroup)) {
          <span class="readonly-field">
            {{ formGroup.controls.description.value || "-" }}
          </span>
        } @else {
          <app-validated-input
            [inputFormControl]="formGroup.controls.description"
            inputFormControlName="description"
            [omitKeydownEnter]="true"
          />
        }
      </td>

      <td class="col-action">
        <div class="actions">
          @if (canDownloadUploadedFile(formGroup)) {
            <button
              type="button"
              class="btn btn-link btn-sm action-btn"
              [attr.aria-label]="'general.download' | translate"
              [attr.title]="'general.download' | translate"
              (click)="onDownloadClick($event, formGroup)"
            >
              <span class="fas fa-download"></span>
            </button>
          }

          @if (!hasExistingFile(formGroup)) {
            <button
              type="button"
              class="btn btn-link btn-sm action-btn"
              [attr.aria-label]="'general.upload' | translate"
              [attr.title]="'general.upload' | translate"
              (click)="onUploadClick(index)"
            >
              <span class="fas fa-upload"></span>
            </button>
          }

          @if (hasExistingFile(formGroup)) {
            <button
              type="button"
              class="btn btn-link btn-sm action-btn"
              [attr.aria-label]="'general.replace' | translate"
              [attr.title]="'general.replace' | translate"
              (click)="onReplaceClick(index)"
            >
              <span class="fas fa-sync-alt"></span>
            </button>
          }

          @if (hasExistingFile(formGroup) || canAdd()) {
            <button
              type="button"
              class="btn btn-link btn-sm action-btn text-danger"
              [attr.aria-label]="'general.delete' | translate"
              [attr.title]="'general.delete' | translate"
              (click)="onFileRemove($event, index)"
            >
              <span class="far fa-trash-alt"></span>
            </button>
          }

          <input
            type="file"
            hidden
            #fileInputs
            (change)="onFileSelected($event, index)"
          />
        </div>
      </td>
    </ng-container>
  </ng-template>
</app-form-array-table>
